/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetTrainerAvailabilitySlotsParams,
  MicrosoftAspNetCoreMvcProblemDetails,
  TrainWithMeModulesBookingDtosResponsesBookingSlotsResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTrainerAvailabilitySlots = (
    params?: GetTrainerAvailabilitySlotsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesBookingDtosResponsesBookingSlotsResponse>(
      {url: `/trainer-availability/slots`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTrainerAvailabilitySlotsQueryKey = (params?: GetTrainerAvailabilitySlotsParams,) => {
    return [
    `/trainer-availability/slots`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTrainerAvailabilitySlotsQueryOptions = <TData = Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(params?: GetTrainerAvailabilitySlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrainerAvailabilitySlotsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>> = ({ signal }) => getTrainerAvailabilitySlots(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrainerAvailabilitySlotsQueryResult = NonNullable<Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>>
export type GetTrainerAvailabilitySlotsQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetTrainerAvailabilitySlots<TData = Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params: undefined |  GetTrainerAvailabilitySlotsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>,
          TError,
          Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrainerAvailabilitySlots<TData = Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetTrainerAvailabilitySlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>,
          TError,
          Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrainerAvailabilitySlots<TData = Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetTrainerAvailabilitySlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrainerAvailabilitySlots<TData = Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetTrainerAvailabilitySlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerAvailabilitySlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrainerAvailabilitySlotsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






